import { Tooltip } from "@mui/material";
import { Matchmaker } from "models/BO/Matchmaker";
import { useEffect, useState } from "react";
import { getMMListByIDs } from "utils/matchmakerUtils";

export const MMNames = ({ ids }) => {
  const [mmNames, setMMNames] = useState("");
  useEffect(() => {
    getMMListByIDs(ids).then((res) => {
      setMMNames(res?.map((mm) => mm.user.first_name + " " + mm.user.last_name).join(", "));
    });
  }, [ids]);
  return (
    <Tooltip title={mmNames}>
      <div>{mmNames}</div>
    </Tooltip>
  );
};
